import script from "./RatingStars.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingStars.vue?vue&type=script&setup=true&lang=js"

import "./RatingStars.vue?vue&type=style&index=0&id=78e79750&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78e79750"]])

export default __exports__